<jqxLoader #loader [imagePosition]="'top'" [width]="100" [height]="60" [text]="translate('Procesando')">
</jqxLoader>
<jqxWindow #form [theme]="environment.tema" [width]="1110" [height]="528" [zIndex]="50" [position]="getFormPos(form)"
    [autoOpen]="true" [zIndex]="90" [showCloseButton]="true" [showCollapseButton]="true" [resizable]="false"
    (onClose)="onClose()">
    <div class="formHeader" style="overflow-x: hidden;">
        {{translate('Listado_volumetricos')}}
    </div>
    <div class="form" style="float:left; overflow-x: hidden;">
        <div style="float: left; margin-top: 2px; clear: both;">
            <div style="float: left; width: 335px;">{{translate('Periodo')}}</div>
            <div style="float: left;">{{translate('Volumetricos')}}</div>
            <div style="float: left; clear: both;">
                <app-periodo-select #periodoSelect [noAnno]="true" [noTrimestre]="true" [noSemestre]="true"
                    [noLibre]="false" [height]="24">
                </app-periodo-select>
                <jqxDropDownList #cbVolumetricos style="float:left; margin-left: 4px;" [width]="230" [height]="24"
                    [selectedIndex]="0">
                </jqxDropDownList>
                <jqxButton style="float:left; margin-left: 18px;" [width]='100' [height]='26'
                    [textImageRelation]='"imageBeforeText"' [textPosition]='"left"' [imgSrc]='"/assets/images/save.png"'
                    [value]="translate('ACEPTAR')" (onClick)="onAceptar($event)">
                </jqxButton>
                <jqxButton style="float:left; margin-left: 4px;" [width]='100' [height]='26'
                    [textImageRelation]='"imageBeforeText"' [textPosition]='"left"'
                    [imgSrc]='"/assets/images/exportar.png"' [value]="translate('Exportar')"
                    (onClick)="onExportar($event)">
                </jqxButton>
            </div>
        </div>
        <div style="float:left; margin-top: 6px; width: 100%; height: 400px;">
            <jqxGrid #grid [theme]="environment.tema" [width]="'100%'" [height]="'100%'" [source]="dataAdapter"
                [columnsresize]="true" [sortable]="true" [showrowlines]="false" [showcolumnlines]="true"
                [columns]="columns" [altrows]="true" [sortmode]="'many'" [enabletooltips]="true" [filterable]="false"
                [showstatusbar]="true" [statusbarheight]="20" [showaggregates]="true" [rowsheight]="20"
                [columnsheight]="20" [localization]="langGrid" [groupable]="true" [showtoolbar]="true"
                [rendertoolbar]="createToolBar" (onBindingcomplete)="onBindingComplete()"
                (onRowclick)="onRowClick($event)">
            </jqxGrid>
        </div>
        <div style="float: left; margin-top: 8px; width: 100%;">
            <jqxButton style="float:left;" [width]='100' [height]='26' [textImageRelation]='"imageBeforeText"'
                [textPosition]='"left"' [imgSrc]='"/assets/images/center.png"' [value]="translate('Centrar')"
                (onClick)="onCentrar($event)">
            </jqxButton>
            <jqxButton style="float: left; margin-left: 4px;" [width]='90' [height]='26'
                [textImageRelation]='"imageBeforeText"' [textPosition]='"left"' [imgSrc]='"/assets/images/grafica.png"'
                [value]="translate('Grafico')" (onClick)="onGrafica($event)">
            </jqxButton>
            <jqxButton style="float: left; margin-left: 4px;" [width]='150' [height]='26'
                [textImageRelation]='"imageBeforeText"' [textPosition]='"left"' [imgSrc]='"/assets/images/resumen.png"'
                [value]="translate('Resumen') + ' ' + translate('Periodo').toLowerCase()" (onClick)="onResumen($event)">
            </jqxButton>
            <jqxButton style="float: left; margin-left: 4px;" [width]='80' [height]='26'
                [textImageRelation]='"imageBeforeText"' [textPosition]='"left"' [imgSrc]='"/assets/images/total.png"'
                [value]="translate('Total')" (onClick)="onTotal($event)">
            </jqxButton>
        </div>
    </div>
</jqxWindow>